/* eslint-disable camelcase */
import { isSnapchatEnabled } from './client';

export interface SnaptrUserData {
  uuid_c1?: string;
  user_email?: string;
  user_phone_number?: string;
}

export const snaptrEvent = (
  eventType: string,
  eventData?: SnaptrUserData | Record<string, unknown>
) => {
  if (
    typeof window !== 'undefined' &&
    isSnapchatEnabled() &&
    window.snaptr &&
    typeof window.snaptr === 'function'
  ) {
    window.snaptr('track', eventType, eventData);
  }
};
